module.exports = __webpack_public_path__ + "static/media/6-en.8d36281.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/audio/6-en.wav
// module id = d0S8
// module chunks = 1